// extracted by mini-css-extract-plugin
module.exports = {"colBtnSearch":"SyncModal_colBtnSearch__3DZDQ","divider":"SyncModal_divider__2j2r_","status":"SyncModal_status___Fpi7","statusErrors":"SyncModal_statusErrors__2lNlN"};